import {
  BuyOrder,
  BuyProcessApiRequest,
  RelationType,
} from '../../../../global/entities/BuyOrder';
import { BuyOrderOrganization } from '../../../../utils/types/buy-order-relations';
import {
  LegalShareholder,
  PhysicalPerson,
} from '../../../../global/entities/Person';
import { RadioTrueFalseString } from '../../../../utils/radio/radio';

type PhysicalShareholderRelation = {
  person: string;
  numberShares: number;
  relationId?: string;
  relationType: RelationType;
};

type LegalShareholderRelation = {
  numberShares: number;
  relationType: RelationType;
  person: string;
  organization: string;
};

export type OwnerSharesStoreState = Pick<
  BuyProcessApiRequest,
  'beneficialOwnerHelp'
> & {
  numberShares: 250 | 500;
  shareCapital: 25_000 | 50_000;
  physicalPeople: PhysicalShareholderRelation[];
  legalShareholders: BuyOrderOrganization<LegalShareholderRelation>[];
};

export type OwnerSharesFormState = Pick<BuyOrder, 'shareCapital'> & {
  physicalPeople?: (PhysicalPerson & { relationId?: string })[];
  legalShareholders?: LegalShareholder[];
  beneficialOwnerHelp: RadioTrueFalseString;
  numberShares: '250' | '500';
};

export type OwnerSharesMetaFields = {
  minShareholders: boolean;
  remainingShares: number;
};

export const OwnerSharesFieldLabels = {
  hasLegalShareholders:
    'Har bolaget några juridiska personer, t.ex. företag, som ägare?',
  numberShares: 'Aktiekapital',
  shares250: '25 000 SEK / 250 aktier',
  shares500: '50 000 SEK / 500 aktier',
} as const;

export const OwnerSharesFieldNames = {
  hasLegalShareholders: 'hasLegalShareholders',
  numberShares: 'numberShares',
  shares250: '250',
  shares500: '500',
} as const;
